// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { iconButtonClasses } from '@mui/material/IconButton';
import { svgIconClasses } from '@mui/material/SvgIcon';
import { rem } from '../../tokens/conversions';
import { iconButtonColors } from './iconButtonColors';
export var IconButton = function(mode) {
    var c = iconButtonColors(mode);
    var override = {
        MuiIconButton: {
            styleOverrides: {
                root: function(param) {
                    var ownerState = param.ownerState;
                    var isContained = ownerState.variant === 'contained';
                    var isOutlined = ownerState.variant === 'outlined';
                    var isTranslucent = ownerState.variant === 'translucent';
                    var isSecondaryContained = ownerState.variant === 'secondaryContained';
                    var isSecondaryOutlined = ownerState.variant === 'secondaryOutlined';
                    var isSecondaryText = ownerState.variant === 'secondaryText';
                    var isInvertedContained = ownerState.variant === 'invertedContained';
                    var isInvertedOutlined = ownerState.variant === 'invertedOutlined';
                    var isInvertedText = ownerState.variant === 'invertedText';
                    var isText = !isContained && !isOutlined && !isTranslucent && !isSecondaryContained && !isSecondaryOutlined && !isSecondaryText && !isInvertedContained && !isInvertedOutlined && !isInvertedText;
                    var getVariantColors = function() {
                        if (isContained) {
                            return c.contained;
                        }
                        if (isOutlined) {
                            return c.outlined;
                        }
                        if (isTranslucent) {
                            return c.translucent;
                        }
                        if (isSecondaryContained) {
                            return c.secondaryContained;
                        }
                        if (isSecondaryOutlined) {
                            return c.secondaryOutlined;
                        }
                        if (isSecondaryText) {
                            return c.secondaryText;
                        }
                        if (isInvertedContained) {
                            return c.invertedContained;
                        }
                        if (isInvertedOutlined) {
                            return c.invertedOutlined;
                        }
                        if (isInvertedText) {
                            return c.invertedText;
                        }
                        return c.text;
                    };
                    var variantColors = getVariantColors();
                    return _object_spread_props(_object_spread({
                        borderRadius: rem(8),
                        '&:focus-visible, &.Mui-focusVisible': {
                            outline: "".concat(rem(2), " solid ").concat(c.focus.border),
                            outlineOffset: rem(2)
                        }
                    }, isContained && {
                        backgroundColor: c.contained.default.background,
                        color: c.contained.default.icon,
                        '&:hover, &.pseudo-hover': {
                            backgroundColor: c.contained.hover.background
                        },
                        '&:active, &.pseudo-active': {
                            backgroundColor: c.contained.active.background,
                            color: c.contained.active.icon
                        }
                    }, isOutlined && {
                        border: "".concat(rem(1), " solid ").concat(c.outlined.default.border),
                        color: c.outlined.default.icon,
                        '&:hover, &.pseudo-hover': {
                            border: "".concat(rem(1), " solid ").concat(c.outlined.default.border),
                            backgroundColor: c.outlined.hover.background
                        },
                        // Triple-boost: IconButtonGroup's own divider rule on non-last
                        // icon buttons (`& > .MuiIconButton-root:not(:last-of-type)`,
                        // specificity 3) otherwise beats a plain `&:active` (specificity
                        // 2) and keeps the group-facing border stuck at the resting color
                        // while pressed. See Button.tsx's `&&&:active` for the same fix.
                        '&&&:active, &&&.pseudo-active': {
                            border: "".concat(rem(1), " solid ").concat(c.outlined.active.border),
                            backgroundColor: c.outlined.active.background,
                            color: c.outlined.active.icon
                        }
                    }, isTranslucent && {
                        backgroundColor: c.translucent.default.background,
                        color: c.translucent.default.icon,
                        '&:hover, &.pseudo-hover': {
                            backgroundColor: c.translucent.hover.background
                        },
                        '&:active, &.pseudo-active': {
                            backgroundColor: c.translucent.active.background,
                            color: c.translucent.active.icon
                        }
                    }, isSecondaryContained && {
                        background: c.secondaryContained.default.background,
                        color: c.secondaryContained.default.icon,
                        '&:hover, &.pseudo-hover': {
                            background: c.secondaryContained.hover.background
                        },
                        '&:active, &.pseudo-active': {
                            background: c.secondaryContained.active.background,
                            color: c.secondaryContained.active.icon
                        }
                    }, isSecondaryOutlined && {
                        background: c.secondaryOutlined.default.background,
                        border: "".concat(rem(1), " solid ").concat(c.secondaryOutlined.default.border),
                        color: c.secondaryOutlined.default.icon,
                        '&:hover, &.pseudo-hover': {
                            background: c.secondaryOutlined.hover.background
                        },
                        // Triple-boost: see IconButtonGroup's divider-rule note on
                        // `isOutlined` above.
                        '&&&:active, &&&.pseudo-active': {
                            background: c.secondaryOutlined.active.background,
                            border: "".concat(rem(1), " solid ").concat(c.secondaryOutlined.active.border),
                            color: c.secondaryOutlined.active.icon
                        }
                    }, isSecondaryText && {
                        backgroundColor: 'transparent',
                        color: c.secondaryText.default.icon,
                        '&:hover, &.pseudo-hover': {
                            background: c.secondaryText.hover.background
                        },
                        '&:active, &.pseudo-active': {
                            background: c.secondaryText.active.background,
                            color: c.secondaryText.active.icon
                        }
                    }, isText && {
                        backgroundColor: 'transparent',
                        color: c.text.default.icon,
                        '&:hover, &.pseudo-hover': {
                            backgroundColor: c.text.hover.background
                        },
                        '&:active, &.pseudo-active': {
                            backgroundColor: c.text.active.background,
                            color: c.text.active.icon
                        }
                    }, isInvertedContained && {
                        backgroundColor: c.invertedContained.default.background,
                        color: c.invertedContained.default.icon,
                        '&:hover, &.pseudo-hover': {
                            backgroundColor: c.invertedContained.hover.background
                        },
                        '&:active, &.pseudo-active': {
                            backgroundColor: c.invertedContained.active.background,
                            color: c.invertedContained.active.icon
                        }
                    }, isInvertedOutlined && {
                        border: "".concat(rem(1), " solid ").concat(c.invertedOutlined.default.border),
                        color: c.invertedOutlined.default.icon,
                        '&:hover, &.pseudo-hover': {
                            border: "".concat(rem(1), " solid ").concat(c.invertedOutlined.hover.border),
                            backgroundColor: c.invertedOutlined.hover.background
                        },
                        '&&&:active, &&&.pseudo-active': {
                            border: "".concat(rem(1), " solid ").concat(c.invertedOutlined.active.border),
                            backgroundColor: c.invertedOutlined.active.background,
                            color: c.invertedOutlined.active.icon
                        }
                    }, isInvertedText && {
                        backgroundColor: 'transparent',
                        color: c.invertedText.default.icon,
                        '&:hover, &.pseudo-hover': {
                            backgroundColor: c.invertedText.hover.background
                        },
                        '&:active, &.pseudo-active': {
                            backgroundColor: c.invertedText.active.background,
                            color: c.invertedText.active.icon
                        }
                    }), // [Fixes G16] Triple-ampersand to override MUI ButtonBase's disabled styles.
                    // [Fixes G17] Single block with conditional properties to avoid duplicate key drops.
                    _define_property({}, "&&&.".concat(iconButtonClasses.disabled), _object_spread({
                        color: variantColors.disabled.icon
                    }, isContained && {
                        backgroundColor: c.contained.disabled.background
                    }, isOutlined && {
                        border: "".concat(rem(1), " solid ").concat(c.outlined.disabled.border)
                    }, isTranslucent && {
                        backgroundColor: c.translucent.disabled.background
                    }, isSecondaryContained && {
                        background: c.secondaryContained.disabled.background
                    }, isSecondaryOutlined && {
                        border: "".concat(rem(1), " solid ").concat(c.secondaryOutlined.disabled.border)
                    }, isInvertedContained && {
                        backgroundColor: c.invertedContained.disabled.background
                    }, isInvertedOutlined && {
                        border: "".concat(rem(1), " solid ").concat(c.invertedOutlined.disabled.border)
                    })));
                },
                sizeSmall: _define_property({
                    padding: rem(4),
                    minWidth: rem(28),
                    minHeight: rem(28)
                }, "& .".concat(svgIconClasses.root), {
                    fontSize: rem(16)
                }),
                sizeMedium: _define_property({
                    padding: rem(8)
                }, "& .".concat(svgIconClasses.root), {
                    fontSize: rem(20)
                }),
                sizeLarge: _define_property({
                    padding: rem(12)
                }, "& .".concat(svgIconClasses.root), {
                    fontSize: rem(24)
                })
            },
            // [Fixes G18] Extra Small is a custom size — use `variants`, not `styleOverrides`.
            variants: [
                {
                    props: {
                        size: 'extraSmall'
                    },
                    style: _define_property({
                        padding: rem(2),
                        minWidth: rem(20),
                        minHeight: rem(20),
                        borderRadius: rem(4)
                    }, "& .".concat(svgIconClasses.root), {
                        fontSize: rem(12)
                    })
                }
            ],
            defaultProps: {
                color: 'primary',
                size: 'medium',
                disableTouchRipple: true,
                variant: 'text'
            }
        }
    };
    return override;
};

//# sourceMappingURL=IconButton.js.map